import React, { useState, useRef } from 'react';

import useClickOutsideRef from '../../../hooks/useClickOutsideRef';
import styles from '../../../../pages/ClubProfiles/club.scss';
import config from '../../../../../config';

const ClubLeagues = ({ leagues }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownWrapper = useRef(null);

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    const handleOnLeagueSelect = () => {
        const currentLeague = leagues[0];
        window.location.href = `${config.leaguesAppHost}/leagues/${currentLeague?.id}`;
    };

    useClickOutsideRef(dropdownWrapper, () => setShowDropdown(false));

    return (
        leagues?.length > 1 ? (
            <div ref={dropdownWrapper} className="dropdown">
                <button className="btn btn-default dropdown-toggle btn-sm text-uppercase" type="button" id="dropdownMenuButton" onClick={toggleDropdown} aria-haspopup="true" aria-expanded="false">
                        Team Leagues
                </button>
                <div className={`dropdown-menu ${styles.leaguesDropdown} ${showDropdown ? 'd-block' : 'd-none'}`} role="menu" aria-labelledby="dropdownMenuButton">
                    {leagues.map(league => <a key={league.id} className="dropdown-item" target="_blank" rel="noopener noreferrer" href={`${config.leaguesAppHost}/leagues/${league?.id}`}>{league?.label}</a>)}
                </div>
            </div>
        ) : (
            <button
                type="button"
                className={`btn btn-default btn-sm text-uppercase ${styles.primaryActionButton}`}
                onClick={handleOnLeagueSelect}
            >
                Team Leagues
            </button>
        )

    );
};

export default ClubLeagues;
